import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

const presetStyles = {
  "default": {},
  "body": {
    marginLeft: "5px"
  },
  "header": {
    position: "absolute",
    right: "-.4em",
    top: "-.4em"
  },
  "footer": {
    marginLeft: "5px",
    marginRight: "5px"
  }
};

export class Badge extends PureComponent {
  render() {
    const { children, className, dot, style, preset, ...others } = this.props;
    const cls = classNames({
      "weui-badge": true,
      "weui-badge_dot": dot
    }, className);
    const styles = Object.assign({}, presetStyles[preset], style);

    return (
      <span className={ cls } style={ styles } { ...others }>{ children }</span>
    );
  }
}
